import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { connectState } from '@examdojo/angular/util';
import { IconComponent } from '@examdojo/core/icon';
import { Tag } from '@examdojo/core/ontology';
import { SelectableTreeCellComponent, SelectableTreeCellRendererBaseComponent } from '@examdojo/core/tree';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { map } from 'rxjs';
import { VerificationIndicator } from '../domain-node.interface';

@UntilDestroy()
@Component({
  selector: 'exam-ontology-domain-explorer-cell-renderer',
  standalone: true,
  imports: [IconComponent, MatTooltip, MatCheckboxModule, SelectableTreeCellComponent],
  templateUrl: './ontology-domain-explorer-cell-renderer.component.html',
  styleUrls: ['./ontology-domain-explorer-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OntologyDomainExplorerCellRendererComponent
  extends SelectableTreeCellRendererBaseComponent<Tag, VerificationIndicator>
  implements ICellRendererAngularComp
{
  private readonly verificationStatus$ = this.node$.pipe(map((node) => node?.metadata));

  private readonly verificationTooltip$ = this.verificationStatus$.pipe(
    map((status) => {
      switch (status) {
        case 'verified':
          return 'Fully verified (2+ reviewers)';
        case 'partial':
          return 'Partially verified (1 reviewer or in progress)';
        case 'none':
          return 'Not verified';
        default:
          return '';
      }
    }),
  );

  private readonly reviewerCount$ = this.node$.pipe(
    map((node) => {
      if (!node?.originalData?.verification) {
        return '';
      }
      const count = node.originalData.verification.length;
      return count > 0 ? String(count) : '';
    }),
  );

  readonly state = connectState({
    node: this.node$,
    expanded: this.isExpanded$$,
    selected: this.isSelected$$,
    indeterminate: this.isIndeterminate$$,
    nestingLevel: this.nestingLevel$,
    isGroup: this.isGroup$,
    verificationStatus: this.verificationStatus$,
    verificationTooltip: this.verificationTooltip$,
    reviewerCount: this.reviewerCount$,
  });
}
